export const isProductionHost = () => /^portal\.servers\./.test(window.location.hostname);
